import EventTypes from '@/common/api/definitions/event-types';
import BaseAction from '@/modules/rules-engine/actions/base-action';
import ReminderActionModel from '@/common/models/rules/actions/reminder-action-model';

export default {
    extends: BaseAction,
    computed: {
        systemEventGroup() {
            return Object.keys(ReminderActionModel.SupportedEventGroups)
                .find(group => ReminderActionModel.SupportedEvents[group]
                    .includes(this.systemEventType));
        },
        canHaveRole() {
            return this.systemEventGroup === ReminderActionModel.SupportedEventGroups.subscription;
        },
        relatedEvent() {
            switch (this.systemEventGroup) {
                case ReminderActionModel.SupportedEventGroups.subscription:
                    return 'renewal/trial end';
                case ReminderActionModel.SupportedEventGroups.invoice:
                    return 'past due';
                case ReminderActionModel.SupportedEventGroups.paymentCard:
                    return 'expiration';
                default:
                    return '...';
            }
        },
        relatedEventName() {
            switch (this.systemEventGroup) {
                case ReminderActionModel.SupportedEventGroups.subscription:
                    return this.role;
                case ReminderActionModel.SupportedEventGroups.invoice:
                    return 'past due';
                case ReminderActionModel.SupportedEventGroups.paymentCard:
                    return 'expiration';
                default:
                    return '...';
            }
        },
        relatedEntityName() {
            switch (this.systemEventGroup) {
                case ReminderActionModel.SupportedEventGroups.subscription:
                    return 'subscription';
                case ReminderActionModel.SupportedEventGroups.invoice:
                    return 'invoice';
                case ReminderActionModel.SupportedEventGroups.paymentCard:
                    return 'payment card';
                default:
                    return '...';
            }
        },
        humanizedRelatedEvent() {
            switch (this.systemEventGroup) {
                case ReminderActionModel.SupportedEventGroups.subscription:
                    return `a subscription ${this.role === this.roles.renewal ? 'renews' : 'trial ends'}`;
                case ReminderActionModel.SupportedEventGroups.invoice:
                    return 'an invoice is past due';
                case ReminderActionModel.SupportedEventGroups.paymentCard:
                    return 'an active subscriber\'s default payment card expires';
                default:
                    return '...';
            }
        },
        relatedReminderEvent() {
            switch (this.systemEventGroup) {
                case ReminderActionModel.SupportedEventGroups.subscription:
                    return this.role === this.roles.renewal
                        ? EventTypes.subscriptionRenewalReminder
                        : EventTypes.subscriptionTrialEndReminder;
                case ReminderActionModel.SupportedEventGroups.invoice:
                    return EventTypes.invoicePastDueReminder;
                case ReminderActionModel.SupportedEventGroups.paymentCard:
                    return EventTypes.paymentCardExpirationReminder;
                default:
                    return null;
            }
        },
        defaultRole() {
            return this.canHaveRole
                ? this.roles.trialEnd
                : this.roles.all;
        },
        roles() {
            return ReminderActionModel.Roles;
        },
        selectableRoles() {
            return {
                [this.roles.trialEnd]: 'Trial End',
                [this.roles.renewal]: 'Renewal',
            };
        },
        availableRoles() {
            return this.canHaveRole
                ? [this.roles.trialEnd, this.roles.renewal]
                : [this.roles.all];
        },
        role() {
            return this.action.role
                || this.defaultRole;
        },
    },
    methods: {
        updateRole(role) {
            this.$emit('input', this.action.cloneSelf({role}));
        },
    },
    mounted() {
        if (!this.availableRoles.includes(this.role)) {
            this.updateRole(this.defaultRole);
        }
    },
};
